// "Often bought with..." upsell: adds the chosen variant to the cart without leaving the product page.
// The cart icon and drawer contents update in place, and the button confirms the add.
if (!customElements.get('upsell-offer')) {
  customElements.define(
    'upsell-offer',
    class UpsellOffer extends HTMLElement {
      connectedCallback() {
        this.status = this.querySelector('[data-status]');
        this.addEventListener('change', (event) => {
          const option = event.target.selectedOptions?.[0];
          const price = event.target.closest('form')?.querySelector('[data-price]');
          if (option && price) price.textContent = option.dataset.price;
        });
        this.addEventListener('submit', (event) => {
          event.preventDefault();
          this.add(event.target);
        });
      }

      sectionsToRender() {
        const sections = [{id: 'Cart-Icon-Bubble', section: 'cart-icon-bubble', selector: '.shopify-section'}];
        const drawer = document.getElementById('Cart-Drawer');
        if (drawer) sections.push({id: 'Cart-Drawer', section: drawer.dataset.section, selector: '#Cart-Drawer-Details'});
        return sections;
      }

      add(form) {
        const button = form.querySelector('button[type="submit"]');
        const label = button.querySelector('[data-label]');
        const sections = this.sectionsToRender();
        const formData = new FormData(form);
        formData.append('sections', sections.map((section) => section.section).join());
        formData.append('sections_url', window.location.pathname);

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = formData;

        button.disabled = true;
        button.classList.add('loading');
        fetch(window.routes.cart_add_url, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {source: 'upsell-offer', productVariantId: formData.get('id'), errors: response.errors || response.description, message: response.message});
              this.announce(response.description || window.variantStrings.unknownError);
              return;
            }
            SectionDynamicUpdate.updateSections(sections, response.sections);
            publish(PUB_SUB_EVENTS.cartUpdate, {source: 'upsell-offer', productVariantId: formData.get('id'), cartData: response});
            label.textContent = this.dataset.added;
            form.dataset.state = 'added';
            this.announce(this.dataset.addedAnnouncement.replace('[product]', response.product_title));
            setTimeout(() => {
              label.textContent = this.dataset.add;
              delete form.dataset.state;
            }, 2500);
          })
          .catch(() => this.announce(window.variantStrings.unknownError))
          .finally(() => {
            button.disabled = false;
            button.classList.remove('loading');
          });
      }

      announce(message) {
        this.status.textContent = message;
      }
    }
  );
}
